import React from 'react';
import { LinearGradient } from 'tamagui/linear-gradient';
import { useTheme } from 'tamagui';

import { CobuStack, CobuText } from '@cobu/ui';

interface StatsCardProps {
  statNumber: number | string;
  label: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({ statNumber, label }) => {
  const theme = useTheme();

  return (
    <LinearGradient
      colors={[
        '$referralStatsPrimary',
        '$referralStatsSecondary',
      ]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={gradientContainer as any}
    >
      <CobuStack 
        ai="center" 
        jc="center" 
        py="$2"
      >
        <CobuText 
          variant="heading" 
          fontSize="$8" 
          fontWeight="bold" 
          color="$white"
        >
          {statNumber}
        </CobuText>
        
        <CobuText 
          variant="body" 
          fontSize="$4" 
          color="$white" 
        >
          {label}
        </CobuText>
      </CobuStack>
    </LinearGradient>
  );
}; 

const gradientContainer = {
  borderRadius: 8,
  flex: 1,
};